import { Button, Result } from "antd";
import { useFlow, FLOWS } from "hook/bailiff/document/flow/useFlow";
import React from "react";
//
//component
//redux
//selector
//actions
//utils
//hook
//str
const BailiffBanned = () => {
  // -------------------------- VAR -----------------------------
  const { flow } = useFlow();
  const isLocked = flow === FLOWS.LOCKED;
  // -------------------------- STATE ---------------------------
  // -------------------------- REDUX ---------------------------
  // -------------------------- FUNCTION ------------------------
  // -------------------------- EFFECT --------------------------
  // -------------------------- DATA FUNCTION -------------------
  // -------------------------- RENDER --------------------------
  // -------------------------- MAIN ----------------------------
  if (!isLocked) return null;
  return (
    <Result
      status="403"
      title="File đang bị khoá hoặc không tồn tại file này"
      subTitle="Xin vui lòng quay lại và thanh toán theo quy trình, nếu như có bất kỳ khó khăn nào trong khi thanh toán xin vui lòng liên hệ Admin"
      extra={
        <Button href="/" type="primary">
          Trở về
        </Button>
      }
    />
  );
};
export default BailiffBanned;
